import esteticPhoto from '../../../shared/assets/photo/Service/estetic_photo.png';
import whitePhoto from '../../../shared/assets/photo/Service/white_photo.png';
import endoPhoto from '../../../shared/assets/photo/Service/endo_photo.png';
import prosthPhoto from '../../../shared/assets/photo/Service/prosth_photo.png';
import implantPhoto from '../../../shared/assets/photo/Service/implant_photo.png';
import esteticPicture from '../../../shared/assets/photo/Service/airflow.png';
import whitePicture from '../../../shared/assets/photo/Service/white.png';
import endoPicture from '../../../shared/assets/photo/Service/endo.png';
import prosthPicture from '../../../shared/assets/photo/Service/prosth.png';
import implantPicture from '../../../shared/assets/photo/Service/implant.png';


export const serviceData = [
    {
        id: 1,
        img: esteticPhoto,
        title: 'ПРОФИЛАКТИКА И ГИГИЕНА',
        description: 'Профилактическая стоматология способствует предотвращению стоматологических проблем до их развития и поддержанию здоровья полости рта в долгосрочной перспективе',
        btn: '/hygiene',
        src: esteticPicture,
    },
    {
        id: 2,
        img: whitePhoto,
        title: 'ЭСТЕТИЧЕСКАЯ СТОМАТОЛОГИЯ',
        description: 'Отбеливание зубов — это самый простой и экономичный способ сделать вашу улыбку красивее',
        btn: '/hygiene',
        src: whitePicture,
    },
    {
        id: 3,
        img: endoPhoto,
        title: 'ЭНДОДОНТИЯ',
        description: 'Лечение корневых каналов  остановит дальнейшее разрушение зуба, и вы почувствуете немедленное облегчение боли.',
        btn: '/endodontics',
        src: endoPicture,
    },
    {
        id: 4,
        img: prosthPhoto,
        title: 'ПРОТЕЗИРОВАНИЕ',
        description: 'Отсутствие зубов вызывает ряд серьезных проблем – начиная от общения и внешнего вида до серьезного ухудшения общего здоровья, преждевременного старения.',
        btn: '/prosthetics',
        src: prosthPicture,
    },
    {
        id: 5,
        img: implantPhoto,
        title: 'ХИРУРГИЯ И ИМПЛАНТАЦИЯ',
        description: 'Дентальные имплантаты — это долгосрочное решение, позволяющее заменить отсутствующие зубы, восстановить улыбку и улучшить качество жизни.',
        btn: '/implant',
        src: implantPicture,
    },
]